import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getAuthoringProjectDemands = api(() =>
    query(
        gql`
            query GetAuthoringProjectDemands {
                getAuthoringProjectDemands {
                    name
                    id
                    description
                    group
                    purpose
                }
            }
        `,
        {},
        { returns: "getAuthoringProjectDemands" }
    )
)
